import { AfterViewChecked, Component, ElementRef, inject, Inject, Optional, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import {
  MatDialogContent,
} from '@angular/material/dialog';
import {
  InkEditorAnnotation,
  NgxExtendedPdfViewerComponent,
  NgxExtendedPdfViewerModule,
  NgxExtendedPdfViewerService,
  PdfDocumentInfo,
  PdfDocumentPropertiesExtractor,
} from 'ngx-extended-pdf-viewer';
import { BtnSignComponent } from './btn-sign/btn-sign.component';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatToolbarModule } from '@angular/material/toolbar';
import { AnexoService } from '../../services/anexo.service';
import { DocumentoService } from '../../services/documento.service';
import { MatDivider } from '@angular/material/divider';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ScnackbarData, ToastService, SnackbarStyles } from '../toast.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppTitleService } from '../../services/app-title.service';

@Component({
  selector: 'app-dlg-sign',
  imports: [
    NgxExtendedPdfViewerModule,
    MatDialogModule,
    MatButtonModule,
    MatDialogContent,
    MatIconModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    FormsModule,
    MatTooltipModule
  ],
  templateUrl: './dlg-signature.component.html',
  styleUrl: './dlg-signature.component.scss'
})
export class DlgSignatureComponent implements AfterViewChecked {
  firmarAnexo?: boolean
  previousRoute = this.route.snapshot.params["previousRoute"];

  idDoc = this.route.snapshot.params["idDoc"];
  idAnx = this.route.snapshot.params["idAnx"];
  firmar = 0;
  x = 0;
  y = 0;
  page = 1;
  zoomLevels = ['auto', 'page-actual', 'page-fit', 'page-width', 0.33, 0.5, 0.75, 1, 1.25, 1.5, 2];
  _zoomSetting: number | string | undefined = 'auto';
  currentZoomFactor: number = 0;
  isMobile = 'ontouchstart' in document.documentElement;
  loadPdf = false;
  hasAnotations = false;
  totalPage = 1;
  filePdf?: any;
  firmas: any[] = [];
  idAdjunto = 0;

  constructor(
    public dlg: MatDialog,
    public pdfService: NgxExtendedPdfViewerService,
    public anexoServ: AnexoService,
    private route: ActivatedRoute,
    private router: Router,
    public documentoServ: DocumentoService,
    private toast: ToastService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    inject(AppTitleService).setTitle("Firmar archivo");

    if (data) {
      this.idAnx = data.idAnx
    }

    if (this.route.snapshot.url[0]) {
      this.firmarAnexo = this.route.snapshot.url[0].path === "firmarAnexo" ? true : false;
    }

    this.idAdjunto = this.idAnx;
    this.firmar = (this.idDoc) ? 1 : 0;

    this.anexoServ.get(this.idAdjunto).subscribe({
      next: (res: Blob) => {
        this.filePdf = res;
      }
    });
    documentoServ.getFirmasList().subscribe({
      next: (res: any) => {
        this.firmas = res;
      }
    })
  }
  ngAfterViewChecked(): void {
    const control = document.getElementById("txtPage");
    if (control && control.childElementCount > 1) {
      control?.lastChild?.remove();
    }
  }

  onPagesLoaded() {
    this.loadPdf = true;
    this.btnZoomIn = document.getElementById('primaryZoomIn');
    this.btnZoomOut = document.getElementById('primaryZoomOut');
    this.setupBackspaceProtection();
  }

  public async addStamp(): Promise<void> {

    await this.insertImage();

    setTimeout(() => {
      this.hasAnotations = this.pdfService.getSerializedAnnotations() != null;
      const tmpStamps = document.getElementsByClassName('stampEditor');
      const tmpStamp = Array.prototype.slice.call(tmpStamps)[0];
      tmpStamp.style.border = '2px dashed red';
      tmpStamp?.parentElement?.classList.remove('disabled');
      tmpStamp?.parentElement?.classList.remove('stampEditing');
      tmpStamp?.firstChild?.remove();
      tmpStamp?.lastChild?.remove();

    }, 100);
  }

  private async insertImage(): Promise<void> {
    const anotationStamp: InkEditorAnnotation = this.getAnotation();
    const divTmp: HTMLElement | null = document.getElementById('editorStampParamsToolbar');
    divTmp?.setAttribute("style", "display: none;");
    await this.pdfService.addEditorAnnotation(anotationStamp);

  }
  public removeStamp() {
    this.pdfService.removeEditorAnnotations();
    this.hasAnotations = this.pdfService.getSerializedAnnotations() != null
    this.x = 0;
  }

  public signPdf() {
    const anotation = this.pdfService.getSerializedAnnotations();
    if (anotation) {
      const dlgSign = this.dlg.open(BtnSignComponent, {
        data: {
          x: anotation[0].rect[0],
          y: anotation[0].rect[1],
          adj: this.idAdjunto,
          pagina: anotation[0].pageIndex + 1
        }
      });
      dlgSign.afterClosed().subscribe(result => {
        if (result && !this.firmarAnexo) {
          this.onCerrarDocumento();
          return
        }
        if (result) {
          const snackbarData: ScnackbarData = {
            message: "Anexo firmado",
            style: SnackbarStyles.Success,
            iconName: "check_circle"
          }
          this.toast.show(snackbarData)
          this.router.navigateByUrl(`/${this.previousRoute}/${this.idDoc}`)
          return
        }
      });
    }
  }

  onCerrarDocumento() {
    this.documentoServ.cerrarDocumento(this.idDoc).subscribe({
      next: (_) => {
        const snackbarData: ScnackbarData = {
          message: "Documento firmado enviado",
          style: SnackbarStyles.Success,
          iconName: "check_circle"
        }
        this.toast.show(snackbarData)
        this.pdfViewer.ngOnDestroy();
        this.router.navigateByUrl("/enviado")
      }
    })
  }


  @ViewChild(NgxExtendedPdfViewerComponent, { static: false })
  private pdfViewer!: NgxExtendedPdfViewerComponent;
  onBackToResumen() {
    this.pdfViewer.ngOnDestroy();
    this.router.navigateByUrl("finalizar/" + this.idDoc)
  }

  private getAnotation(): any {
    const divs = document.getElementsByClassName('textLayer');
    const div = Array.prototype.slice.call(divs)[0];
    const matchesW = div.style.width.match(/[0-9]+/);
    const width = matchesW[0];
    const matchesH = div.style.height.match(/[0-9]+/);
    const height = matchesH[0];

    const divsPages = Array.prototype.slice.call(divs);
    let px = "";
    let pageSign = 0;
    let contPage = 0;
    //divsPages.forEach((page) => {
    var page = divsPages[0];
    const inputList = Array.prototype.slice.call(page.childNodes);
    inputList.forEach((element) => {
      if (element.innerText === 'Atentamente,') {
        const matchesL = element.style.left.match(/[0-9]+/);
        if(matchesL){
          px = matchesL.input;
          this.x = matchesL[0];
          const matchesT = element.style.top.match(/[0-9]+/);
          this.y = matchesT[0];
          pageSign = contPage;
        }
      }
      if (this.x == 0) {
        element.childNodes.forEach((element1: any) => {
          if (element1.innerText === 'Atentamente,') {
            const matchesL = element1.style.left.match(/[0-9]+/);
            px = matchesL.input;
            this.x = matchesL[0];
            const matchesT = element1.style.top.match(/[0-9]+/);
            this.y = matchesT[0];
            pageSign = contPage;
          }
        });
      }
    });
    contPage++;
    //});
    this.x = Number.parseInt(this.x.toString());
    this.y = Number.parseInt(this.y.toString());
    if (this.x === 0) {
      this.x = width - 138;
      this.y = height - 64;
    } else {
      if (px.includes("%")) {
        this.x = (width * this.x) / 100;
        this.y = height - (height * this.y) / 100 - 64;
      } else {
        this.y = height - this.y - 64;
      }
    }

    return {
      annotationType: 13,
      //pageIndex: pageSign,
      pageIndex: this.page - 1,
      bitmapUrl: './assets/stamp.png',
      letf: 50,
      right: 50,
      top: 50,
      rect: [this.x + 2, this.y + 2, this.x + 120, this.y + 44],
      rotation: 0,
    };
  }

  public get zoomSetting() {
    return String(this._zoomSetting);
  }
  public set zoomSetting(zoom: string) {
    if (isNaN(Number(zoom))) {
      this._zoomSetting = zoom;
    } else {
      this._zoomSetting = zoom + '%';
    }
  }
  public updateZoomFactor(zoom: number): void {
    this.currentZoomFactor = zoom;
  }

  btnZoomIn?: HTMLElement | null;
  btnZoomOut?: HTMLElement | null;
  public zoomIn(): void {
    this.btnZoomIn?.click();
  }
  public zoomOut(): void {
    this.btnZoomOut?.click();
  }

  private keyListener!: (event: KeyboardEvent) => void;
  @ViewChild('pdfContainer') pdfContainer!: ElementRef;
  private setupBackspaceProtection(): void {
    this.keyListener = (event: KeyboardEvent) => {
      if (event.key === 'Backspace' || event.key === 'Delete') {
          event.stopPropagation();
      }
    };
    document.addEventListener('keydown', this.keyListener, true);
  }
}
